// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Regular Styles */
html {
    box-sizing: border-box;
}

*,
*:before,
*:after {
    box-sizing: inherit;
}

@font-face {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-stretch: normal;
    src: url(https://fonts.gstatic.com/s/opensans/v34/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsjZ0B4gaVc.ttf) format('truetype');
}

body {
    font-family: "Open Sans", sans-serif;
    color: #4e555f;
    font-size: 14px;
}

/* Bar Delays Animation Function */
/* Chart Styles */
.chart-wrap_bus {
    /* border: 1px solid #eeeeee;
    max-width: 900px;
    margin: 0 auto;
    padding: 10px; */
    margin-top: 7px;
}

.chart-wrap_bus .chart-title {
    margin-bottom: 10px;
    font-size: 16px;
    text-align: center;
    text-transform: uppercase;
}

.chart-wrap_bus .row {
    position: relative;
    height: 26px;
    /* margin-bottom: 15px; */
    /* margin-bottom: 7px; */
    margin: 0px 5px 7px 5px;
}

.chart-wrap_bus .bar-wrap_bus {
    position: relative;
    background: #d7dbde;
    width: 100%;
    height: 100%;
    overflow: hidden;
}

.chart-wrap_bus .bar-wrap_bus .bar_bus {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    /* background: #f37167; */
    background: #83A4CF;
    transition: all 1s;
    transform: translateX(-100%);
}

.chart-wrap_bus .bar-wrap_bus .bar_bus.in {
    transform: translateX(0%);
}

.chart-wrap_bus .row:nth-of-type(1) .bar_bus {
    transition: 1s 400ms;
}

.chart-wrap_bus .row:nth-of-type(2) .bar_bus {
    transition: 1s 600ms;
}

.chart-wrap_bus .row:nth-of-type(3) .bar_bus {
    transition: 1s 800ms;
}

.chart-wrap_bus .row:nth-of-type(4) .bar_bus {
    transition: 1s 1000ms;
}

.chart-wrap_bus .row:nth-of-type(5) .bar_bus {
    transition: 1s 1200ms;
}

.chart-wrap_bus .row:nth-of-type(6) .bar_bus {
    transition: 1s 1400ms;
}

.chart-wrap_bus .row:nth-of-type(7) .bar_bus {
    transition: 1s 1600ms;
}

.chart-wrap_bus .label {
    position: absolute;
    top: 0;
    left: 0;
    /* width: 150px; */
    width: 60px;
    padding-left: 10px;
    text-align: left;
    font-size: 12px;
    line-height: 26px;
    text-transform: uppercase;
    font-weight: bold;
    z-index: 10;
}

.chart-wrap_bus .number {
    position: absolute;
    top: 0;
    right: 0;
    padding-right: 5px;
    line-height: 26px;
    font-weight: bold;
    text-align: right;
    z-index: 10;
}

@media screen and (min-width: 800px) {
    .chart-wrap_bus .row {
        /* changed */
        /* padding: 2px 25px 2px 40px; */
        padding: 2px 0px 2px 40px;
        /* changed */
    }

    .chart-wrap_bus .label {
        /* text-align: right; */
        padding-left: 0;
        /* padding-left: 15px; */
    }

    .chart-wrap_bus .number {
        text-align: right;
        /* changed */
        /* padding-right: 0px; */
        padding-right: 5px;
        /* changed */
    }
}`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard_Bus/Faultanalysis_Bus/FaultFirstPage_Bus/Horizantal_bus.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;IACI,sBAAsB;AAC1B;;AAEA;;;IAGI,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,qIAAqI;AACzI;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd,eAAe;AACnB;;AAEA,kCAAkC;AAClC,iBAAiB;AACjB;IACI;;;oBAGgB;IAChB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;IACzB,wBAAwB;IACxB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI;QACI,YAAY;QACZ,gCAAgC;QAChC,yBAAyB;QACzB,YAAY;IAChB;;IAEA;QACI,uBAAuB;QACvB,eAAe;QACf,wBAAwB;IAC5B;;IAEA;QACI,iBAAiB;QACjB,YAAY;QACZ,wBAAwB;QACxB,kBAAkB;QAClB,YAAY;IAChB;AACJ","sourcesContent":["/* Regular Styles */\nhtml {\n    box-sizing: border-box;\n}\n\n*,\n*:before,\n*:after {\n    box-sizing: inherit;\n}\n\n@font-face {\n    font-family: 'Open Sans';\n    font-style: normal;\n    font-weight: 400;\n    font-stretch: normal;\n    src: url(https://fonts.gstatic.com/s/opensans/v34/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsjZ0B4gaVc.ttf) format('truetype');\n}\n\nbody {\n    font-family: \"Open Sans\", sans-serif;\n    color: #4e555f;\n    font-size: 14px;\n}\n\n/* Bar Delays Animation Function */\n/* Chart Styles */\n.chart-wrap_bus {\n    /* border: 1px solid #eeeeee;\n    max-width: 900px;\n    margin: 0 auto;\n    padding: 10px; */\n    margin-top: 7px;\n}\n\n.chart-wrap_bus .chart-title {\n    margin-bottom: 10px;\n    font-size: 16px;\n    text-align: center;\n    text-transform: uppercase;\n}\n\n.chart-wrap_bus .row {\n    position: relative;\n    height: 26px;\n    /* margin-bottom: 15px; */\n    /* margin-bottom: 7px; */\n    margin: 0px 5px 7px 5px;\n}\n\n.chart-wrap_bus .bar-wrap_bus {\n    position: relative;\n    background: #d7dbde;\n    width: 100%;\n    height: 100%;\n    overflow: hidden;\n}\n\n.chart-wrap_bus .bar-wrap_bus .bar_bus {\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 100%;\n    /* background: #f37167; */\n    background: #83A4CF;\n    transition: all 1s;\n    transform: translateX(-100%);\n}\n\n.chart-wrap_bus .bar-wrap_bus .bar_bus.in {\n    transform: translateX(0%);\n}\n\n.chart-wrap_bus .row:nth-of-type(1) .bar_bus {\n    transition: 1s 400ms;\n}\n\n.chart-wrap_bus .row:nth-of-type(2) .bar_bus {\n    transition: 1s 600ms;\n}\n\n.chart-wrap_bus .row:nth-of-type(3) .bar_bus {\n    transition: 1s 800ms;\n}\n\n.chart-wrap_bus .row:nth-of-type(4) .bar_bus {\n    transition: 1s 1000ms;\n}\n\n.chart-wrap_bus .row:nth-of-type(5) .bar_bus {\n    transition: 1s 1200ms;\n}\n\n.chart-wrap_bus .row:nth-of-type(6) .bar_bus {\n    transition: 1s 1400ms;\n}\n\n.chart-wrap_bus .row:nth-of-type(7) .bar_bus {\n    transition: 1s 1600ms;\n}\n\n.chart-wrap_bus .label {\n    position: absolute;\n    top: 0;\n    left: 0;\n    /* width: 150px; */\n    width: 60px;\n    padding-left: 10px;\n    text-align: left;\n    font-size: 12px;\n    line-height: 26px;\n    text-transform: uppercase;\n    font-weight: bold;\n    z-index: 10;\n}\n\n.chart-wrap_bus .number {\n    position: absolute;\n    top: 0;\n    right: 0;\n    padding-right: 5px;\n    line-height: 26px;\n    font-weight: bold;\n    text-align: right;\n    z-index: 10;\n}\n\n@media screen and (min-width: 800px) {\n    .chart-wrap_bus .row {\n        /* changed */\n        /* padding: 2px 25px 2px 40px; */\n        padding: 2px 0px 2px 40px;\n        /* changed */\n    }\n\n    .chart-wrap_bus .label {\n        /* text-align: right; */\n        padding-left: 0;\n        /* padding-left: 15px; */\n    }\n\n    .chart-wrap_bus .number {\n        text-align: right;\n        /* changed */\n        /* padding-right: 0px; */\n        padding-right: 5px;\n        /* changed */\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
